import PropTypes from "prop-types";
export var intlMessageObject = {
  id: PropTypes.string,
  defaultMessage: PropTypes.string,
  args: PropTypes.shape({})
};
export var intlMessageShape = PropTypes.oneOfType([PropTypes.string, PropTypes.shape(intlMessageObject)]);